'use client'

import Link from 'next/link'
import type React from 'react'

interface ChatKitLoginGateProps {
  icon: React.ComponentType<{ className?: string }>
  title: string
  description: string
  redirectUrl: string
}

export function ChatKitLoginGate({
  icon: Icon,
  title,
  description,
  redirectUrl,
}: ChatKitLoginGateProps) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16 bg-gradient-to-b from-[#04070f] via-[#050914] to-[#04070f]">
      <div className="max-w-2xl w-full text-center border border-white/10 rounded-3xl bg-white/5 p-10 shadow-2xl shadow-black/30">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-500/10 text-indigo-300">
          <Icon className="h-7 w-7" />
        </div>
        <h2 className="text-3xl font-semibold text-white mb-4">{title}</h2>
        <p className="text-slate-300 leading-relaxed mb-8">{description}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href={`/login?redirect=${encodeURIComponent(redirectUrl)}`}
            className="inline-flex items-center justify-center rounded-full bg-indigo-600 px-8 py-3 text-base font-semibold text-white shadow-[0_0_25px_rgba(99,102,241,0.35)] transition hover:bg-indigo-500"
          >
            Log in to continue
          </Link>
          <Link
            href="/signup"
            className="inline-flex items-center justify-center rounded-full border border-white/20 px-8 py-3 text-base font-semibold text-white/80 hover:border-white/40 hover:text-white"
          >
            Create free account
          </Link>
        </div>
      </div>
    </div>
  )
}
